// Extend Javascript ____________________________________________________________

// Turns a string into title/camel case
// eg. "the quick brown fox" => "The Quick Brown Fox"
//
String.prototype.toTitleCase = function() {
	return this.toLowerCase().replace(/(?:^|\s)\w/g, function( match ) {
        return match.toUpperCase();
    });
};

// Pads a number with zeros, to a length
// eg. 123 => 000123
//
Number.prototype.zeroPad = function( len ) {
	var str = this + '';
	return ( str.length >= len ? str : new Array(len - str.length + 1).join('0') + str );
};



// Custom _______________________________________________________________________

// Scroll Frame
// Prevents scroll event propagating to other elements
// 
JLM.MT.preventScrollOverflow = function( event ) {
	var target = $( event.currentTarget ),
		prevent_scroll = true,
		direction = ( event.originalEvent.deltaY > 0 ? 1 : -1 );
	
	if ( direction < 0 && target[0].scrollTop > 0 ) {
		prevent_scroll = false;
	} else if ( direction > 0 && target[0].scrollTop < ( target[0].scrollHeight - target.height() ) ) {
		prevent_scroll = false;
	}
	
	if ( prevent_scroll ) event.preventDefault();
};


// Talent name URL
// 
JLM.MT.generateTalentNameURL = function( talent_name ) {
	talent_name = talent_name.replace(/[^A-Za-z\s\u00C0-\u017F-]/g, '');
	talent_name = talent_name.replace(/\s+/g, '-');
	talent_name = talent_name.replace(/-+/g, '-');
	return talent_name;
};


// Talent profile link
// 
JLM.MT.generateTalentProfileLink = function( division_type, talent_name ) {
	// Division
	if ( division_type == 'voices' ) division_type = 'voice-actors';
	
	// Talent name
	talent_name = JLM.MT.generateTalentNameURL(talent_name);
	
	return '/our-' + division_type + '/' + talent_name;
};


// Talent profile full name
// 
JLM.MT.generateTalentProfileFullname = function( firstname, lastname ) {
	let fullname = [];
	firstname = $.trim( firstname );
	lastname = $.trim( lastname );
	
	if ( firstname ) fullname.push( firstname );
	if ( lastname ) fullname.push( lastname );
	return fullname.join(' ');
};


// Division name formatting
// 
JLM.MT.generateDivisionName = function( division ) {
	switch ( division ) {
		case JLM.NS.DIVISION_MCS_ENTERTAINERS:
			return 'MCs &amp; Entertainers &amp; Speakers';
		case JLM.NS.DIVISION_WRITERS_DIRECTORS:
			return 'Writers &amp; Directors';
		default:
			division = division.replace(/[_-]/g, ' ');
			return division.toTitleCase();
	}
};
JLM.MT.generateDivisionSingular = function( division ) {
	if ( division === JLM.NS.DIVISION_MCS_ENTERTAINERS ) {
		division = 'mcs';
	} else if ( division === JLM.NS.DIVISION_WRITERS_DIRECTORS ) {
		division = 'writer-directors';
	}
	division = division.replace(/_/g, ' ');
	return division.substr(0, division.length - 1);
};


// Updates layout (mobile / desktop)
// 
JLM.MT.getLayout = function() {
	// Temporary way to detect layout
	let is_large = ( parseInt( $('#jl_navigation').css('right') ) > 0 );
	if ( is_large ) return JLM.NS.LAYOUT_LARGE;
	return JLM.NS.LAYOUT_SMALL;
};


// Creates download URL for Bio PDF
// 
JLM.MT.generateBioURL = function( talent_id, talent_url, division ) {
	let division_singular = JLM.MT.generateDivisionSingular( division );
	if ( JLM.mobile ) {
		return '/view/bio/' + talent_url + '_' + division_singular + '.pdf';
	} else {
		return '/download/bio/' + talent_url + '/' + division_singular;
	}
};


// Check if email address is valid
// 
JLM.MT.isValidEmailAddress = function( email_address ) {
	var REGEX_EMAIL = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	return ( email_address && email_address.match( REGEX_EMAIL ) );
};


// Turns object into URL query string
// 
JLM.MT.paramsToQueryString = function( params ) {
	let list_params = [];
	for( var key in params ) {
		if ( params.hasOwnProperty( key ) ) {
			list_params.push( encodeURIComponent(key) + '=' + encodeURIComponent( params[key] ) );
		}
	}
	return list_params.join('&');
};


// Track event in GA
// 
JLM.MT.trackEvent = function( type, parameters ) {
	if ( window.gtag ) gtag('event', type, parameters);
	
	/*
	// If Google Analytics not embedded
	if ( !window.ga ) {
		window.ga = function() {
			if ( window.console && window.console.log ) {
				console.log('Track: ', arguments);
			}
		};
	}
	
	// Track
	try {
		let data_packet = {
			eventCategory: category,
			eventAction: action,
			eventLabel: label
		};
		if ( value ) data_packet.eventValue = value;
		if ( beacon ) data_packet.transport = 'beacon';
		window.ga('send', type, data_packet);
	}
	catch( err ) {}
	*/
};
JLM.MT.trackPageview = function( url ) {
	// If Google Analytics not embedded
	if ( !window.ga ) {
		window.ga = function() {
			if ( window.console && window.console.log ) {
				console.log('Track: ', arguments);
			}
		};
	}
	
	// Track
	try { window.ga('send', 'pageview', url); }
	catch( err ) {}
};



